export default {
  reset: () => {
    if (window.mixpanel) {
      window.mixpanel.reset();
    }
  }
};